import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={20} height={20} fill="none" {...props}>
    <Path
      fill="#000"
      d="M7.28 16.63v-.769h2.34v-3.825c-1.2-.184-2.141-.702-2.824-1.554-.682-.853-1.023-1.847-1.023-2.983V3.36h8.462V7.5c0 1.136-.343 2.13-1.027 2.983-.685.852-1.625 1.37-2.82 1.554v3.825h2.34v.77H7.28ZM10 11.279c.88 0 1.65-.327 2.308-.98.658-.652 1.035-1.458 1.131-2.417H6.561c.1.96.478 1.766 1.134 2.418.656.653 1.424.979 2.305.979ZM6.542 7.111h6.924v-2.98H6.542v2.98Z"
    />
  </Svg>
);
export default SvgComponent;
